<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y85H89/tc-custom/9781613732168.jpg?1701641264787" alt="This image is the cover for the book Peculiar People"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peculiar People
      </h1>
      <p class="bookDescription body article font2">
        <p>These days hardly anyone remembers Augustus John Curthbert Hare (1834-1903). But in his prime, the late Victorian age, his name was on the lips of anyone who mattered. He was a travel writer, a storyteller and a memoirist of the first order, and his work is a fascinating record of a lost way of life amongst the strangest upper classes of English society. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Augustus Hare
      </h2>
      
      <p class="authorDescription body article">Augustus John Cuthbert Hare (1834-1903) was a Victorian writer who had clung, so to speak, to the edges of fame. He was born into the maddest of upper-class English families and survived one of the cruelest of childhoods to write monumental travel guides to the Continent and a six-volume autobiography, The Story of My Life. That autobiography is now extremely rare and growing rarer - since every day copies of it, even in libraries, crumble into dust. This is a one-volume condensation of this remarkable work, containing what the editors consider to be the highlights of Augustus Hare&#39;s harrowing tale, beginning with his birth, shortly following which his lackadaisical parents gave him to a relative, assuring her that if she wanted more children she should let them know, because they had others. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chicago Review Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f174af5a